export const tokenWhiteListEnvironment = [
  'https://nexus-campaign-files-dev.s3.amazonaws.com/EMAIL/',
  'https://nexus-campaign-files-dev.s3.amazonaws.com/SMS/',
  'https://nexus-campaign-files-hml.s3.amazonaws.com/EMAIL/',
  'https://nexus-campaign-files-hml.s3.amazonaws.com/SMS/',
];
